import { GETCOUNT, DECREASECOUNT } from '../actions/ChatActions';

const initialState = {
    count: 0,
};

export const chatReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETCOUNT:
            return {
                ...state,
                count: action.payload,
            }
        case DECREASECOUNT:
            return {
                ...state,
                count: action.payload,
            }
        default:
            return state;
    }
}